/*
 * Authors: mariushirjanu
 * Created: 18/05/2018
 */
import { Injectable } from '@angular/core';

import { IContact, IDescribedObject, INamedObject, IWebshop } from '@type_definitions/datatypes';
import { HttpDataService } from '@app/shared/http/http-data.service';
import { IWebshopRequest } from './webshop.service';
import { TranslationService } from '@app/shared/translation/translation.service';

@Injectable()
export class WebshopDataService {
  constructor(
    private httpDataService:HttpDataService,
    private translationService:TranslationService
  ) {
    //empty
  }

  public webshops(workflowType?:string, stockOrderType?:string):Promise<INamedObject[]> {
    return this.httpDataService.doGET(
      'rest/orderentry/webshops',
      { workflowType, stockOrderType },
      undefined,
      'Error loading webshops'
    );
  }

  public webshopsWithReadOnlyAccess(workflowType?:number):Promise<INamedObject[]> {
    return this.httpDataService.doGET(
      'rest/orderentry/webshops',
      {
        workflowType: workflowType,
        withReadOnlyAccess: true
      },
      undefined,
      'Error loading webshops'
    );
  }

  public webshopPhases():Promise<IDescribedObject[]> {
    return this.httpDataService.doGET(
      'rest/orderentry/webshopphases',
      undefined,
      undefined,
      'Error loading webshop phases'
    );
  }

  public searchWebshops(name:string):Promise<IWebshop[]> {
    return this.httpDataService.doGET(
      'rest/webshops',
      { name },
      undefined,
      'Error getting webshops'
    );
  }

  public addWebshop(webshop:IWebshopRequest):Promise<INamedObject> {
    return this.httpDataService.doPOST(
      'rest/webshops',
      undefined,
      webshop,
      this.translationService.instant('GA.GENERAL.SAVING', { label: this.translationService.instant('GA.GENERAL.WEBSHOP') }),
      'Error saving webshops'
    );
  }

  public getWebshopContacts(webshopId:number, contactType:string, filter:string):Promise<IContact[]> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/contacts`,
      {
        contactType,
        filter
      },
      undefined,
      'Error getting webshop contacts'
    );
  }

  public getWebshop(webshopId:number):Promise<IWebshop> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}`
    );
  }
}